import { FC } from 'react';

import routes from '../../../routes'
import WaveEventInfo from '../../WaveEventInfo';
import { VideoTemplateProps } from '../../WaveEventModal/VideoTemplate';
import TemplateWithSlider from '../TemplateWithSlider';

const { Router } = routes;

import TemplateWithInfoWrapper, { ScrollableContentWrapper } from './Wrapper';

const TemplateWithInfo: FC<VideoTemplateProps> = props => (
  <TemplateWithInfoWrapper>
    <ScrollableContentWrapper>
      <WaveEventInfo {...props} />
    </ScrollableContentWrapper>
    <TemplateWithSlider onTemplateEdit={Router.back} />
  </TemplateWithInfoWrapper>
);

export default TemplateWithInfo;
